
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire437f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire437f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7O781", function(module, exports) {

$parcel$export(module.exports, "register", () => $5af2bb7662e33e3a$export$6503ec6e8aabbaf, (v) => $5af2bb7662e33e3a$export$6503ec6e8aabbaf = v);
var $5af2bb7662e33e3a$export$6503ec6e8aabbaf;
var $5af2bb7662e33e3a$export$f7ad0328861e2f03;
"use strict";
var $5af2bb7662e33e3a$var$mapping = new Map();
function $5af2bb7662e33e3a$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$5af2bb7662e33e3a$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $5af2bb7662e33e3a$var$resolve(id) {
    var resolved = $5af2bb7662e33e3a$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$5af2bb7662e33e3a$export$6503ec6e8aabbaf = $5af2bb7662e33e3a$var$register;
$5af2bb7662e33e3a$export$f7ad0328861e2f03 = $5af2bb7662e33e3a$var$resolve;

});

var $33088fa2f6b7bf98$exports = {};

(parcelRequire("7O781")).register(new URL("", import.meta.url).toString(), JSON.parse('["2BF4I","index.1d709e3a.js","iZyFL","dmodel.1d159bf2.glb"]'));


//# sourceMappingURL=index.runtime.d900af6b.js.map
